/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5ab233dd9895843d701c091e16e284b143d39b40";
